import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  data: function data() {
    return {
      menuEmpty: [{
        title: '空菜单演示',
        icon: 'folder-o',
        children: [{
          title: '空菜单 1',
          children: [{
            title: '空菜单 1-1'
          }, {
            title: '空菜单 1-2'
          }]
        }, {
          title: '空菜单 2'
        }, {
          title: '空菜单 3'
        }]
      }],
      headerChanged: false,
      asideChanged: false,
      headerBak: [],
      asideBak: []
    };
  },
  computed: _objectSpread({}, mapState('d2admin/menu', ['header', 'aside', 'asideTransition'])),
  created: function created() {
    this.headerBak = cloneDeep(this.header);
    this.asideBak = cloneDeep(this.aside);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.headerChanged && this.asideChanged) {
      this.headerSet(this.headerBak);
      this.asideSet(this.asideBak);
      this.$notify({
        title: '菜单恢复',
        message: '对侧边栏和顶栏菜单的修改已经复原',
        type: 'success'
      });
      return;
    }

    if (this.headerChanged) {
      this.headerSet(this.headerBak);
      this.$notify({
        title: '菜单恢复',
        message: '对顶栏菜单的修改已经复原',
        type: 'success'
      });
      return;
    }

    if (this.asideChanged) {
      this.asideSet(this.asideBak);
      this.$notify({
        title: '菜单恢复',
        message: '对侧边栏菜单的修改已经复原',
        type: 'success'
      });
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('d2admin/menu', ['headerSet', 'asideSet'])), mapActions('d2admin/menu', ['asideTransitionToggle'])), {}, {
    /**
     * 修改顶栏菜单
     */
    handleHeaderSet: function handleHeaderSet() {
      this.headerChanged = true;
      this.headerSet(this.menuEmpty);
      this.$notify({
        title: '菜单修改',
        message: '对顶栏菜单的修改已经生效',
        type: 'success'
      });
    },

    /**
     * 修改侧边栏菜单
     */
    handleAsideSet: function handleAsideSet() {
      this.asideChanged = true;
      this.asideSet(this.menuEmpty);
      this.$notify({
        title: '菜单修改',
        message: '对侧边栏菜单的修改已经生效',
        type: 'success'
      });
    },

    /**
     * 恢复顶栏菜单
     */
    headerReset: function headerReset() {
      this.headerSet(this.headerBak);
      this.$notify({
        title: '菜单恢复',
        message: '对顶栏菜单的修改已经复原',
        type: 'success'
      });
    },

    /**
     * 恢复侧边栏菜单
     */
    asideReset: function asideReset() {
      this.asideSet(this.asideBak);
      this.$notify({
        title: '菜单恢复',
        message: '对侧边栏菜单的修改已经复原',
        type: 'success'
      });
    }
  })
};